import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {QuickInsertCommandSpec} from './quickInsertTypes';

/*
 * Props.
 */

interface Props {
  command: QuickInsertCommandSpec;
  countMatching: number;
  onSelect: () => void;
}

/*
 * Style.
 */

const StyledCommandNameDiv = styled.div`
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.medium};
`;

const StyledCommandNameMatchSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

const StyledCommandDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.small};
`;

/*
 * Component.
 */

export const QuickInsertCommandDropdownItem: FC<Props> = (props: Props) => {
  const {command, countMatching, onSelect} = props;
  const {name, description} = command;

  const match = name.slice(1, countMatching + 1);
  const rest = name.slice(countMatching + 1);

  return (
    <DropdownItem onSelect={onSelect}>
      <DropdownItemIcon iconName={command.iconName} label={command.iconLabel} />
      <DropdownItemContent>
        <StyledCommandNameDiv>
          /{Boolean(countMatching) && <StyledCommandNameMatchSpan>{match}</StyledCommandNameMatchSpan>}
          {rest}
        </StyledCommandNameDiv>
        <StyledCommandDescriptionDiv>{description}</StyledCommandDescriptionDiv>
      </DropdownItemContent>
    </DropdownItem>
  );
};
